















import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";

import UnitModal from "./UnitModal.vue";
import unitModel from "@/models/unit.model";
import unitManagerModel from "@/models/unitManager.model";


@Component({
	name: "units",
	components: {
		PaginatedSearch,
		UnitModal,
		CreationCard,
		FormField,
	},
})
export default class Units extends Vue {
	entityModel: any;
	unitId: string = "";

	unitCreationFields = [
		{ key: "name", class: "md-size-50" },
		{ key: "cnpj", class: "md-size-25" },
		{ key: "address.phone", class: "md-size-25" },
		{ key: "address.postalCode", class: "md-size-20" },
		{ key: "address.street", class: "md-size-30" },
		{ key: "address.number", class: "md-size-25" },
		{ key: "address.complement", class: "md-size-25" },
		{ key: "address.state", class: "md-size-20" },
		{ key: "address.city", class: "md-size-30" },
		{ key: "address.district", class: "md-size-50" },
		{ key: "unitManager", class: "md-size-50", props: { manyToOneModel: unitManagerModel } },
	];

	constructor() {
		super();
		this.entityModel = unitModel;
	}

	async mounted() {
		this.unitId = this.$route.params.id;
	}

	openEntity(unit: any) {
		this.$router.push(`/administrativo/unidades/${unit.id}`);
	}

	closeUnitModal() {
		this.$router.push('.');
		(this.$refs.unitsPaginatedSearch as any).refresh();
	}

	@Watch("$route")
	updateRoute(route: any) {
		if (route.params.id) {
			this.unitId = route.params.id;
		} else {
			this.unitId = "";
		}
	}
}
